import { graphql } from '@/gql';
import type { SubmitQaCalibrationMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export type QaCalibrationInput = SubmitQaCalibrationMutationVariables['data'];

export const submitQaCalibration = async (data: QaCalibrationInput) => {
  const response = await mutationExecute({
    variables: {
      data,
    },
    mutation: graphql(`
      mutation submitQaCalibration($data: QaCalibrationInputType!) {
        submitQaCalibration(data: $data) {
          id
          createdAt
        }
      }
    `),
  });

  return response.data?.submitQaCalibration;
};
